import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, tap } from 'rxjs';
import { AppService } from '../services/app.service';
import { AuthService } from '../services/auth.service';

export const oktaGroupGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean> => {
    const appService = inject(AppService);
    const translate = inject(TranslateService);
    const authService = inject(AuthService);

    return authService.isGroupMember(route.data['expectedGroup'] || []).pipe(
        tap(authorized => {
            if (!authorized) {
                appService.showMsg(translate.instant('route.noPermission'), 'error');
            }
        })
    );
}
